import React from 'react';
import Users from './Users';
import currentUserState from '@globalState/currentUserState';

export default () => {
  const currentUser = currentUserState.useValue();
  return <div>{currentUser?.isAdmin || currentUser?.isMaster ? <Users /> : null}</div>;
};
